import React, { useRef, useState, useEffect } from "react";

const CustomCarousel = ({ children, colsMobile = 2, colsDesktop = 4 }) => {
  const carouselRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const updateScrollPosition = () => {
      if (carouselRef.current) {
        setScrollPosition(carouselRef.current.scrollLeft);
      }
    };

    carouselRef.current?.addEventListener("scroll", updateScrollPosition);
    return () => carouselRef.current?.removeEventListener("scroll", updateScrollPosition);
  }, []);

  const scrollAmount = 250;

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !carouselRef.current) return;
    const deltaX = e.touches[0].clientX - startX;
    carouselRef.current.scrollLeft -= deltaX;
    setStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className="ml-2 pr-2 relative w-full overflow-hidden">

      {/* Carousel Container: Ensure Scrolling Works But Hide Scrollbar */}
      <div
        ref={carouselRef}
        className="flex overflow-x-auto scrollbar-hide scroll-smooth space-x-1 "
        style={{
          display: "flex",
          flexWrap: "nowrap",
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {React.Children.map(children, (child) => (
          <div
            style={{
              flex: `0 0 ${100 / (isMobile ? colsMobile : colsDesktop)}%`,
              maxWidth: `${100 / (isMobile ? colsMobile : colsDesktop)}%`,
            }}
          >
            {child}
          </div>
        ))} 
      </div>

      {/* Arrow Wrapper: Moves Arrows Above Images */}
      <div className="w-full flex justify-between items-center border-t border-b bg-opacity-90    backdrop-blur-lg mb-2 px-2 ">

        {/* Left Arrow */}
        <button
          onClick={scrollLeft}
          className="text-gray-700 p-2 hover:bg-gray-200 transition-all"
        >
          ◀
        </button>

        {/* Right Arrow */}
        <button
          onClick={scrollRight}
          className="text-gray-700 p-2 hover:bg-gray-200 transition-all"
        >
          ▶
        </button>
      </div>





      {/* Hide Scrollbar for Webkit Browsers (Chrome, Safari) */}
      <style>
        {`
          .flex.overflow-x-auto::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
    </div>
  );
};

export default CustomCarousel;
